import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { getUserDetails, updateUserProfile } from '../actions/userActions'
import ReactGA from 'react-ga4';
import { Button, TextField, Container, Box, Typography, Paper, Stack, Grid } from '@mui/material'
import SEO from '../components/SEO'

function ProfileScreen() {

    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [message, setMessage] = useState('')

    const dispatch = useDispatch()

    const history = useNavigate()
   
    const userLogin = useSelector(state => state.userLogin)
    const { userInfo} = userLogin

    const userDetailsState = useSelector(state => state.userDetails)
    const { loading, userDetails, error } = userDetailsState

    const userUpdateProfileState = useSelector(state => state.userUpdateProfile)
    const { updating, updated, updateError } = userUpdateProfileState

    useEffect(() => {
        if (!userInfo){
            history('/login', { replace: true})
        } else if (!userDetails) {
            dispatch(getUserDetails())
        } else if (userDetails) {
            setName(userDetails.name)
            setEmail(userDetails.email)
            setPassword('')
            setConfirmPassword('')
        }
    }, [dispatch, userDetails])

    const submitHandler = (e) => {
        e.preventDefault()

        if (password != confirmPassword){
            setMessage('Passwords do not match')
        } else {
            // check for changes
            if (email == userInfo.email && password == '') {
                // nothing has changed
            } else {
                dispatch(updateUserProfile({
                    'id': userInfo.id,
                    'name': name,
                    'email': email,
                    'password': password,
                }))
                setMessage('')
            }
        }
    }
    
    return (
        <>
            <SEO 
                title="My Profile - PCR Assistant"
                description="Manage your PCR Assistant profile settings, preferences, and account information."
                canonicalUrl="/profile"
            />
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Box sx={{ maxWidth: 600, mx: 'auto' }}>
                    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
                        User Profile
                    </Typography>

                    {message && <Message variant='danger'>{message}</Message>}
                    {error && <Message variant='danger'>{error}</Message>}
                    {updateError && <Message variant='danger'>{updateError}</Message>}
                    {loading && <Loader />}
                    {updating && <Loader />}
                    {updated && <Message variant='success'>Information updated successfully</Message>}
                    { userInfo ?
                    <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                        <Box component="form" onSubmit={submitHandler}>
                            <Stack spacing={3}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="First Name"
                                            disabled
                                            fullWidth
                                            value={userInfo.firstName}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Last Name"
                                            disabled
                                            fullWidth
                                            value={userInfo.lastName}
                                        />
                                    </Grid>
                                </Grid>

                                <TextField
                                    label="Email Address"
                                    disabled
                                    fullWidth
                                    type='email'
                                    value={email}
                                    onChange={(e)=> setEmail(e.target.value)}
                                />

                                <TextField
                                    label="Password"
                                    type='password'
                                    fullWidth
                                    placeholder='Enter Password'
                                    value={password}
                                    onChange={(e)=> setPassword(e.target.value)}
                                />

                                <TextField
                                    label="Confirm Password"
                                    type='password'
                                    fullWidth
                                    placeholder='Confirm Password'
                                    value={confirmPassword}
                                    onChange={(e)=> setConfirmPassword(e.target.value)}
                                />

                                <Button 
                                    type='submit' 
                                    variant='contained'
                                    size="large"
                                    fullWidth
                                    sx={{ height: 48 }}
                                >
                                    Update Profile
                                </Button>
                            </Stack>
                        </Box>
                    </Paper>
                    : '' }
                </Box>
            </Container>
        </>
    )
}

export default ProfileScreen
